document.addEventListener("DOMContentLoaded", function () {
    const triggers = document.querySelectorAll(".click-scroll-on-pdp-section");
    const target = document.querySelector(".main-product-section-element");
    const headerOffset = 100; 

    if (triggers.length && target) {
      triggers.forEach(function (trigger) {
        trigger.addEventListener("click", function (e) {
          e.preventDefault();

          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        });
      });
    }
  });



document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".multiple-images-inner-el");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
      }
    });
  }, {
    threshold: 0.3
  });

  images.forEach(image => {
    observer.observe(image);
  });
});

document.addEventListener('click', function (e) {
  if (e.target.closest('.carousel-static-next-btn')) {
    const wrapper = e.target.closest('.grid__item.product__media-wrapper');
    if (!wrapper) return;
    wrapper.querySelectorAll('.slider-button--next')
      .forEach(btn => btn.click());
    console.log('Desktop Next clicked → Mobile Next triggered');
  }
  if (e.target.closest('.carousel-static-prev-btn')) {
    const wrapper = e.target.closest('.grid__item.product__media-wrapper');
    if (!wrapper) return;
    wrapper.querySelectorAll('.slider-button--prev')
      .forEach(btn => btn.click());
    console.log('Desktop Prev clicked → Mobile Prev triggered');
  }

});



// var mouseclick = new Audio();
// mouseclick.src = "https://uploads.sitepoint.com/wp-content/uploads/2023/06/1687569402mixkit-fast-double-click-on-mouse-275.wav";

// var mouseclick = new Audio();
// mouseclick.src = "https://uploads.sitepoint.com/wp-content/uploads/2023/06/1687569402mixkit-fast-double-click-on-mouse-275.wav";

// document.addEventListener("mousedown", function(e) {
//     if (e.target.closest(".button, .section-btn")) {
//         mouseclick.currentTime = 0; // har baar start se chale
//         mouseclick.play();
//     }
// });

var mouseclick = new Audio("https://uploads.sitepoint.com/wp-content/uploads/2023/06/1687569402mixkit-fast-double-click-on-mouse-275.wav");
mouseclick.preload = "auto";

document.addEventListener("click", function(e) {
    if (e.target.closest(".button, .section-btn")) {
        mouseclick.currentTime = 0;
        mouseclick.play().catch(function(err){
            console.log("Audio play blocked:", err);
        });
    }
});